import { Outlet } from 'react-router-dom';

import { TenantError } from '@/components/routing/TenantError';
import { getRuntimeTenantAlias } from '@/runtimeConfig';

export function TenantGate() {
  const tenantAlias = getRuntimeTenantAlias();

  return !tenantAlias ? <TenantError message={'Tenant alias missing from runtime-config.js.'} /> : <Outlet />;
}
